const translations = {
    location: 'Location'
};

export default translations;
